import { Stack, Typography } from '@mui/material';
import React from 'react';
import { info } from "../helpers/Info";
import "../styles/Servicios.css";
import ServiceItem from './ServiceItem';
import { isMobile } from 'react-device-detect';

const  Servicios =() => {

 

  return (
    <Stack className='servicios'  sx={{ width: isMobile ? "96%":'100%', position: 'relative', backgroundColor: "#fafafa", margin:'0 auto', paddingBottom:'2rem' }} >
         <Typography color="#000" sx={{textAlign: 'center' , fontSize: !isMobile ? '2rem':'1.8rem', padding: isMobile ? '1rem 0': '2rem 0'}} variant="h3">SERVICIOS</Typography>
        <div id='grilla'>
    {info.map((info)=>{
        return <ServiceItem  key={info.id}  services={info.servicios} name={info.title} icon={info.icono}  />

    })}
    </div>
    </Stack>
  )
}



export default Servicios;